import { EventCategories, EventActions, EventLabels } from '../constants/Analytics';

export default function decorateHistoryWithAnalytics(history) {
  history.listen(location => {
    setTimeout(
      () =>
        window.dataLayer.push({
          event: 'sendPageview',
          pagePath: location.pathname,
          pageTitle: document.title
        }),
      2000
    );
  });
  return history;
}

export const registerPinterestTracking = () => {
  window.addEventListener('click', event => {
    const element = event.target || event.srcElement;

    if (!element.getAttribute('data-pin-log')) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'hipagesInteractiveEvent',
      eventCategory: EventCategories.ARTICLES,
      eventAction: EventActions.PINTEREST_CLICK_SAVE_BUTTON,
      eventLabel: EventLabels.PINTEREST_CLICK_SAVE_BUTTON
    });
  });
};

export const trackEvent = (
  eventCategory = '',
  eventAction = '',
  eventLabel = '',
  eventProperty = '',
  eventValue = '',
  interactive = true,
  eventContexts = []
) => {
  if (typeof window === 'undefined') return false;
  if (!window.dataLayer || !window.dataLayer.find(e => e.event === 'gtm.load')) {
    // Delay tracking if we're not loaded yet.
    return setTimeout(
      () =>
        trackEvent(
          eventCategory,
          eventAction,
          eventLabel,
          eventProperty,
          eventValue,
          interactive,
          eventContexts
        ),
      200
    );
  }
  window.dataLayer = window.dataLayer || [];
  // Note: need to reset event in datalayer because of merge issue
  // see: https://plus.google.com/113135228075417071282/posts/ifZ2nBbkJMd
  // see: https://stackoverflow.com/questions/33942649/why-is-gtm-concatenating-object-values-in-datalayer
  window.dataLayer.push({
    event: 'event-reset',
    eventCategory: null,
    eventAction: null,
    eventLabel: null,
    eventProperty: null,
    eventValue: null,
    eventContexts: null
  });
  window.dataLayer.push({
    event: interactive ? 'hipagesInteractiveEvent' : 'hipagesNonInteractiveEvent',
    eventCategory,
    eventAction,
    eventLabel,
    eventProperty,
    eventValue,
    eventContexts: eventContexts.concat(window.pageContexts)
  });
};
